// extracted by mini-css-extract-plugin
export default {"contact":"Services_contact__2U-1E","container":"Services_container__jMDen","card":"Services_card__jKo8N","icon":"Services_icon__8ZrD8","desc":"Services_desc__K7hCg"};